import { render } from "./BaseChart.vue?vue&type=template&id=975f61b8&scoped=true"
import script from "./BaseChart.vue?vue&type=script&lang=js"
export * from "./BaseChart.vue?vue&type=script&lang=js"

import "./BaseChart.vue?vue&type=style&index=0&id=975f61b8&scoped=true&lang=css"

import exportComponent from "/var/www/kim-new-moover/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975f61b8"]])

export default __exports__